module.exports = __webpack_public_path__ + "img/act-of-emotion-inspect-portrait.21edd048.jpg";